export default {
  // 단어
  'profile': 'Account',
  'user': 'User',
  'login': 'Login',
  'logout': 'Logout',
  'ID': 'ID',
  'PW': 'Password',
  'PW_desc': 'Enter 8-12 characters: letters, special characters, and numbers.',
  'PW_confirm': 'Confirm Password',
  'PW_confirm_desc': 'Confirm your password',
  'agreement_view_text': 'Open',
  'required_label': 'Required',
  'PW_origin':'Current Password',
  'PW_new':'New Password',
  'PW_new_confirm':'Confirm New Password',
  'check_email_message':'Please check your email',
  'check_email_desc':'Please click the verification button in your email',
  'footer':'Copyright 2025. LINKMEMINE Inc. All rights reserved.',
  'SC0010': 'Credit',
  'SC0030': 'Bank Transfer',
  'SC0060': 'Mobile billing',
  'Superadmin': 'Free',
  'Corporate': 'Corporate',
  'Basic': 'Basic',
  'Free': 'Free',
  'Email': 'Email',
  'name': 'Name',
  'phone': 'Phone',
  'office_phone': 'Office Phone',
  'subscription_path': 'How did you hear about us?',
  'windows': 'windows',
  'Windows': 'Windows',
  'linux': 'Linux',
  'mac': 'MAC',
  'android': 'Android',
  'agent': 'Agent',
  'download': 'Download',
  'manual': 'Manual',
  'service': 'Service',
  'payment': 'Payment',
  'manage': ' Management',
  'manager': 'Manager',
  'group': 'Group',
  'default_group': 'Default Group',
  'information': 'Information',
  'threshold': 'Threshold', // ?
  'limit': 'Limit',
  'alert': 'Alert',
  'setting': 'Setting',
  'normal': 'Normal', // +
  'device': 'Device',
  'type': 'Type',
  'add': 'Add',
  'add_n': 'Add {v}',
  'remove': 'Remove',
  'delete': 'Delete',
  'progress': 'Progress',
  'time': 'Time',
  'hour': 'Hour',
  'minute': 'Minute',
  'second': 'Second',
  'device-in-group': 'Device in Group',
  'list-of': 'List of {v}',
  'total': 'Total',
  'history': 'History',
  'registration': 'Registration',
  'statistics': 'Statistics',
  'update': 'Update',
  'renew': 'Renew',
  'connected': 'Connected',
  'disconnected': 'Disconnected',
  'running': 'Running',
  'sub-manager': 'User',
  'execute': 'From > To',
  'cancel': 'Cancel',
  'ea': 'EA',
  'WON': 'Won',
  'months': 'Months',
  'years': 'Years',
  'back': 'Back',
  'expire': 'Expired',
  'notify': 'Notification',
  'help': 'Help',
  'status': 'Status',
  'program': 'Program',
  'web': 'Web',
  'proposal': 'Proposal Document',
  'brochure': 'Brochure',
  'ios': 'iOS',
  'etc': 'Other',
  'on-work': 'Currently Unavailable', // ?
  'list-view': 'Thumbnail View',
  'card-view': 'Simple View',
  'live-view': 'Live View',
  'delete-n': 'Delete {v}',
  'move-group-n': 'Move Group {v}', // +
  'selected': 'Selected',
  'accessable': 'Accessible',
  'empty': 'Empty',
  'device_limit': 'Device Limit',
  'device_name': 'Device Name',
  'device_name_identical': 'The agent names are identical.',
  'device_name_edit': 'Change Agent Name',
  'device_name_desc': 'The agent name will be changed from <b>{alias}</b> to the following.<br><br>New agent name:',
  'O/S': 'O/S',
  'edit': 'Edit',
  'refresh': 'Refresh',
  'off-editmode': 'Edit Mode Off',
  'emptied_memo': 'No Memo',
  'upper_group': 'Upper Group',
  'all_device': 'All Devices',
  'submit': 'OK',
  'create': 'Create',
  'delete_group': 'Delete Group',
  'delete_device': 'Delete Device',
  'favorate': 'Favorites',
  'search': 'Search',
  'by_user': '{v} by User',
  'by_device': '{v} by Device',
  'by_type': '{v} by Type',
  'by_daily': 'Daily',
  'by_monthly': 'Monthly',
  'alert_count': 'Alert Count',
  'use_rate': 'Usage',
  'rate': 'Rate',
  'use_count': 'Count',
  'select_date': 'Select Period',
  'connect_count_of_remote': 'Number of Remote Connection',
  'count_of_alert': 'Number of alerts',
  'chart': 'Chart',
  'date': 'Date',
  'host': 'Host',
  'viewer': 'Viewer',
  'at_time': 'Time: ',
  'start_time': '@:date of start',
  'end_time': 'Ended at @:date of end',
  'start_date': 'Start Date',
  'expire_date': 'Expiration Date',
  'event_time': 'Occurrence Date',
  'login_time': 'Access Time',
  'delete_time': 'Deleted Time',
  'payment_date': 'Payment Date',
  'type_of_device': 'Type of Device',
  'alert_message': 'Alert Message',
  'browser': 'Browser',
  'file_name': 'File Name',
  'size': 'File Size',
  'top10': 'Top 10',
  'change': 'Change',
  'do_change': 'Change',
  'advenced_auth': '2-Step Verification',
  'department': 'Department',
  'cowork_position': 'Job Title',
  'timezone': 'Time Zone',
  'date_format': '@:date format',
  'time_sec': '(seconds)',
  'auto_update': 'Auto Update',
  'active': 'Active',
  'inactive': 'Inactive',
  'permission': 'Permission',
  'target': 'Target',
  'common': 'Common',
  'web_manager': 'Web Manager',
  'CS_manager': 'CS (Program) Manager',
  'empty_manager': '@:manager @:empty',
  'empty_phone': '@:phone @:empty',
  'empty_Email': '@:Email @:empty',
  'license': 'License',
  'regist_service': 'Register @:service',
  'update_service': 'Renew @:service',
  'device_type': 'Plan Type',
  'device_vol': 'Device Volume',
  'exceeded_agent_count': 'Exceeded Device Count',
  'remain': 'Remain',
  'period': 'Period',
  'price': 'Price',
  'total_price': 'Total Price',
  'payment_type': 'Product Type',
  'payment_method': 'Payment Method',
  'remark': 'Comment',
  'notice': 'Notice',
  'cs_center': 'Customer Service Center',
  'cs_phone': '070-7126-8663',
  'save': 'Save',
  'find_n': 'Find {v}',
  'signup': 'Sign Up',
  'trial': '15 Days Free Trial',
  'use_for': 'Account Type',
  'personal': 'Personal',
  'enterprise': 'Enterprise',
  'company': 'Company',
  'continue': 'Continue',
  'temperature': 'Temp.',
  'speed': 'Speed',
  'running_time': 'Running Time',
  'system_time': 'System Time',
  'version': 'Version',
  'access_log': 'Controls',
  'list_of_process': 'Processes',
  'list_of_hardware': 'Hardware List',
  'list_of_software': 'Software List',
  'enter_n': 'Enter your {v}',
  'reset_n': 'Reset {v}',
  'authorization': 'Identity Verification',
  'send_n': 'Send {v}',
  'resend_n': 'Resend {v}',
  'close': 'Close',
  'secure': 'Security',
  'max_registrable_devices': 'Maximum Registrable Devices',
  'submanager-right': 'Submanager Permission',
  'access-registration-history': 'Remote Access Request History',
  'access-num': 'Access Number',
  'device-name': 'Device Name',
  'device-ip': 'Device IP',
  'application-date': 'Requested Date',
  'application-period': 'Requested Period',
  'approver': 'Approved By',
  'applicant': 'Requested By',
  'approval-status': 'Status',
  'approval': 'Approved',
  'approval-ing': 'In Progress',
  'function-settings': 'Settings',
  'function-settings01': 'Block unverified users',
  'function-settings02': 'Block users over the time limit',
  'function-settings03': 'File Transfer',
  'blocking-settings': 'Permission',
  'blocking-settings01': 'Blocking Policy',
  'approval-submit-user': 'Re-Apply',
  'blocking-super-settings': 'Use Block Setting',
  'reset-pw': 'Reset',
  'reject-submit': 'Deny',
  'reject': 'Denied',
  'security-access': 'Agree',
  'manager-id': 'Administrator',
  'sub-manager-id': 'Submanager',
  'reject-access': 'Deny',
  'request-agent': 'Request Agent',
  'request-date': 'Request Date',
  'request-reason': 'Reason for Request',
  'approval-reason': 'Reason for Approval',
  'security-access-title':'Agree to Security Policy',
  'excel-form':'Download Excel Form',
  'approval-apply':'Use Approval Process',
  'user-in-group':'Users in Group',
  'deleted-device-edit':'Edit',
  'request-history':'Request History',
  'approval-process':'Requests',
  'approval-process-history':'Approval History',
  'major-os-version':'Major OS Version',
  'minor-os-version':'Minor OS Version',
  'session-time':'Session Duration (min)',
  // @@@
  'password_level' : 'Password difficulty setting',
  'password_level0' : 'No limit (4 to 12 digits)',
  'password_level1' : 'Alphabetical letters and numbers only (6 to 12 digits).',
  'password_level2' : 'Alphabetical letters, numbers and special characters (8 to 12 digits).',
  'password_level3' : 'Uppercase and lowercase letters, numbers, and special characters (8 to 12 digits).',
  'self_unlock' : 'Allow self-unlock when account is locked',
  'self_unlock_desc' : 'Users can unlock their own accounts via self-authentication.',
  'statistics_policy' : 'Statistics Period Settings\n',
  'day' : 'day',
  'month' : 'month',
  'year' : 'year',
  'statistics_period' : 'period',
  'vaccine':'Antivirus Software',
  'capture':'Screenshot and Record',
  'display-power-save':'Save Display Power',
  'system-power-save':'Save System Power',
  'security-agreement':'Use Security Policy',
  'remote-policy':'Remote Access Policy',
  'user-connection-policy':'User Environment Policy',
  'os-version':'Windows Version Allowed',
  'blocking-settings-ip-list':'Allowed IP List',
  'single-ip':'Single IP Address',
  'reason':'Comment',
  'range-ip-start':'Start Range',
  'range-ip-end':'End Range',
  'subnet-ip':'Subnet Mask',
  'time-added':'Time Added',
  'ip-address':'IP Address',
  'password-expired':'Password maximum age (days)',
  'excel-users': 'Add Multiple Users',
  'enrollment': 'Submit',
  'excel-groups': 'Add Multiple Groups',
  'account-manage':'Account',
  'all-devices':'Devices',
  'tutorial':'Quick Guide',
  'device-drop-all':'All Devices',
  'service-payment-history':'Payment History',
  'tutorial-device':'First time? Learn how to add a remote device.',
  'tutorial-group':'Need help with group management?',
  'tutorial-manager':'Learn more about user management.',
  'tutorial-statistics':'What is the dashboard for?',
  'tutorial-download':'Agent download links and installation guides.',
  'tutorial-license':'Need help with online payment?',
  'first-add-device':'Add remote device',
  'system-checker': 'System Environment Checker',

  // 메세지
  'offline_selects': 'Please select an agent that is online.',
  'no-selects': 'No selection.',
  'no-content': 'Does not exist.',
  'on_working': 'In Progress',
  'has_new_message': 'New Message',
  'not_save_warning': 'Changes will not be saved. Do you want to proceed?',
  'not_online_warning': 'Device is offline.',
  'no_input_data': 'No data was entered.',
  'add_child_group': 'Add subgroup in "{name}".<br>Please enter group name.',
  'add_root_group': 'Add subgroup in "ROOT".<br>Please enter group name.',
  'duplication_group_name': 'Group name already exists.',
  'created_group': 'Group has been created.',
  'please_select_group': 'Please select group.',
  'confirm_delete_group': 'Devices within this group will be moved to the default group.<br>Are you sure you want to delete?',
  'deleted_group': 'Group deleted.',
  'all_device_has_no_child': 'You can not include "All Device" in a subgroup.',
  'confirm_delete_device': ` 
    The agent program on the remote machine is logged out.<br>
    If you want to regain control of your device afterwards, you have to log in manually for the first time.<br>
    Are you sure you want to delete?
    <br><br>
    Target: {name} 
  `,
  'access-ticket': '제어권 신청',
  'ticket-request': '제어권 신청 관리',
  'at.requested': '승인요청중',
  'at.re-requested': '재승인요청중',
  'at.approved': '승인완료',
  'at.on-work': '작업중',
  'at.reject': '반려됨',
  'at.completed': '종료',
  'at.Unknown': '알수없는상태',

  'has_request_ticket': '{count}개의 제어권 신청이 있습니다',

  'deleted_device': 'Device Deleted',
  'moved_device': '[{device}] moved to [{group}]',
  'moved_device_by': '[{device}] [{group}]', // ?
  'moved_device_fail': 'Cannot move {name}',
  'deleted_device_count': '[{count}/{total}] Device(s) Deleted.',
  'no_order_warning': 'Cannot modify group order.',
  'delete_user_confirm': 'Are you sure you want to delete this user?',
  'user_active_changed': '"{name}" has been changed to "{status}".',
  'deleted_user': 'User Deleted',
  'created_user': 'User Added',
  'updated_memo': 'Memo Modified',
  'update_agent_requested': 'Update has been requested.',
  'already_latest_version': 'The current version is already up to date.',
  'update_agent_desc': 'Updating the agent program on the remote device.<br>Current Version: {current_ver} Latest Version: {latest_ver}',
  'update_selected_agent_desc': 'Updating the agent programs on the selected remote devices. <br><span style="color: #d9534f;">(Agents that are offline are not included)</span>',
  'delete_threshold': 'Do you want to delete this warning?',
  'no_perm_group': 'You have no access to this group.',
  'add_permission_of_group': `
    Permissions on the parent group below are required to authorize this group.
    <br><br>
    [{groups}]
    <br><br>
    Do you want to allow it?
  `,
  'delete_permission_of_group': `
    To remove the permissions for this group, you need to remove the permissions for the subgroups below.
    <br><br>
    [{groups}]
    <br><br>
    Do you want to allow it?
  `,
  'please_select': 'Please select',
  'please_input': 'Please enter',
  'please_select_device_type': '@:please_select device type',
  'please_select_alert_type': '@:please_select alert type',
  'please_input_alert_time': '@:please_input time',
  'please_input_alert_value': '@:please_input limit',
  'please_input_memo': '@:please_input memo',
  'permissions': {
    'deviceMonitor': 'Monitoring',
    'CSRemoteControl': 'Remote Control',
    'CSFileManager': 'File Transfer',
    'modifyInformation': 'Modify Info',
    'useFunction': 'Reboot/Shutdown',
    'viewReport': 'See Statistics/History',
    'CSRemoteView': 'Remote View',
    'CSDeviceManagement': 'Man. Device',
    'CSUpdate': 'Update',
    'CSThumbnailView': 'See Thumbnail',
    'CSRestart': 'Reboot'
  },
  'getin_with': {
    'internet_search': 'Internet Search',
    'recommendation': 'Recommendation',
    'advertising': 'Advertising',
    'sns': 'Social media/blog',
    'pcany': 'PCAny Pro user',
    'etc': 'Other'
  },
  'added_device_in_group': 'Device added in group',
  'removed_device_in_group': 'Device removed in group',
  'changed_group_info': 'Group Info changed',
  'remote': {
    'remote': {
      'title': 'Remote Access',
      'title2': 'CONNECT',
      'desc': 'Do you want to start remote control?',
      'desc_additional': '<br>(If the remote connection fails, please click the download button to download and run the program.)'
    },
    'transfer': {
      'title': 'File Transfer',
      'desc_additional': '<br>(If the file transfer fails, please click the download button to download and run the program.)',
      'desc': 'Do you want to start file transfer?'
    },
    'reboot': {
      'title': 'Reboot',
      'desc': 'Do you want to reboot?'
    },
    'restart': {
      'title': 'Restart',
      'desc': 'Do you want to restart?',
      'requested': 'Request to restart has been made.'
    },
    'shutdown': {
      'title': 'Shutdown',
      'desc': 'Do you want to start shutdown?'
    },
    'preview': {
      'title': 'Preview'
    },
    'detail': {
      'title': 'Details'
    },
    'delete': {
      'title': 'Delete'
    },
    'wol': {
      'title': 'WOL',
      'desc': 'Wake "{device}" up use below devices. Select device.'
    },
    'approve' : {
      'title': 'Access Denied',
      'desc': 'Request Access'
    },
    'web': {
      'title': 'Remote Access (Web Viewer)'
    },
    'normal' : {
      'title': 'Remote Access (Normal viewer)'
    }
  },
  'columns': {
    'alive': 'Status',
    'actions': 'Functions',
    'alias': 'Device Name',
    'memo': 'Memo',
    'last_connected_time': 'Last Access Date',
    'group': 'Group',
    'connect': 'Connect'
  },
  'id_exist': 'ID does exist.',
  'reserved': {
    'ROOT': 'ROOT'
  },
  'audit-message': {
    '1': '원격제어 기능을 수행하였습니다.',
    '2': '파일관리자 기능을 수행하였습니다.',
    '3': '시스템을 재시작하였습니다.',
    '4': '시스템을 종료하였습니다.',
    '5': '에이전트를 최신버전으로 업데이트 하였습니다.',
    '11': '장치의 이름을 \'{old_value}\'에서 \'{new_value}\'로 변경하였습니다.',
    '12': '장치에 메모를 \'{old_value}\'에서 \'{new_value}\'로 변경하였습니다.',
    '21': '\'{old_value}\'에서 \'{new_value}\'로 그룹을 이동하였습니다.',
    '30': '{old_value} 에서 {new_value} 로 변경하였습니다.',
    '31': '예약(켜기) : {new_value}을 추가하였습니다.',
    '32': '예약(끄기) : {new_value}을 추가하였습니다.',
    '33': '예약(켜기) : {new_value}번째 설정을 제거 하였습니다.',
    '34': '예약(끄기) : {new_value}번째 설정을 제거 하였습니다.',
    '35': '리모컨 : {new_value} 실행하였습니다.'
  },
  'response_error_server_error': '데이터를 불러오는 중 일시적인 오류가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
  'response_error_connect_failed': '서버에 연결할 수 없습니다. 잠시 후 다시 시도해 주세요.',
  'error_page': {
    'session_expired': 'Your session has expired.',
  },
  'not_supported_os': '지원하지 않는 운영체제입니다.',
  'alert_license': '라이센스 만료 알림',
  'need_license': '{v} 라이센스가 필요합니다.',
  'invalid_id_and_pw': 'Please check your ID and password.',
  'login_failed_cause_step1': 'Please check your ID and password.',
  'login_failed_cause_step2': 'Email authentication has not been performed.<br>If you have not received the authentication mail, please press the "Resend Authentication Mail" button.',
  'login_failed_cause_flag_active': 'Your account has been deactivated.<br>Please ask the person in charge.',
  'login_failed_cause_superadmin': 'External access is restricted.',
  'invalid_id': 'Please enter a valid ID.',
  'invalid_otp': 'The OTP authentication code is incorrect. Please try again.',
  'otp_token_expired': 'OTP authentication has timed out. Please log in again.',
  'name_requirement': 'Please enter your name.',
  'phone_requirement': 'Please enter your phone number.',
  'subspath_requirement': 'Please enter your subscription path.',
  'company_name_requirement': 'Please enter your company name.',
  'free_trial_message': '<strong>5 Devices FREE During 15 days!</strong>Join Success!',
  'enter_new_password': 'Enter a new password',
  'accessable_user_desc': 'A list of users with device access in that group.',
  'password_requirement': 'Password must be 8-12 characters, consisting ALL of the following: number, lowercase letter, uppercase letter, and special character.',
  'password_confirm': 'Passwords do not match.',
  'password_modify_mail_sent': 'A password change email has been sent.',
  'password_modified': 'Your password has been changed.',
  'password_modified_failed': 'Password change failed.',
  'otp_reset_complete': 'OTP has been initialized.',
  'otp_reset_failed': 'OTP failed initialization.',
  'password_reset_desc': 'Please reset your password.',
  'forgot_desc': 'Your ID (email) or password could not be found.<br>If you can&#39;t solve it, please contact the customer center.',
  'expired_desc': 'To continue using the service, please <strong style="color: #fd7e14;">renew</strong> your existing license or <br>delete devices that are no longer in use.',
  'email-invalid': 'Please enter the correct email.',
  'navigate_to_home': 'Go to Home',
  'email_verification_success': 'Email verification successful',
  'email_already_verified': 'This email is already verified',
  'email_verification_failed': 'Email verification failed',
  'email_verification_pending': 'Verifying your email...',
  'email-auth-wait': 'Email authentication in progress.<br>Please wait.',
  'email-auth-already': 'Email authentication already completed',
  'email-auth-fail': 'Email authentication failed',
  'email-auth-success': 'Email authentication succeeded.<br>Please log in.',
  'login_description': 'You can access all your PC, smart devices, and IoT devices',
  'join_description': 'Welcome to LinkMeMine!<br>After signing up, please use the service after verifying your email sent to the registered address.',
  'go_login': 'Login',
  'your_email_is': 'Your ID is<br>{email}',
  'not_matched_user': 'No matching users found.',
  'is_pcany_customer': 'Are you currently a paid customer of PCAny?',
  'add_manager_desc': `
    <div>1. Users can be used immediately after creation without any additional authentication.</div>
    <div>2. Admin ID can see all the agent devices that are logged in with the child user ID.</div>
    <div>3. You can set permissions for each User and a group of devices that you can view.</div>
  `,
  'free_trial_comment': 'This is a free trial. Click renew to extend your plan.',
  'secure_login_desc': '만약 보안코드 6자리를 확인할 수 없다면<br>고객센터로 연락주시기 바랍니다.',
  'payment_tax_desc1': '*부가세 포함이며, 1년 약정시 2개월분 금액이 할인됩니다.<br>** 제품 유형(라이센스) 변경 및 1년이상 장기 약정 희망시 고객 센터로 문의 바랍니다.<br>전화번호 : 070-7126-8663',
  'payment_tax_desc2': '세금계산서 필요시 입금 안내',
  'payment_tax_desc3': 'Contact Us: Customer Support +82-2-839-7500 (Press 2)<br>support@linkmemine.com',
  'payment_tax_desc4': 'To change the number of agents or the product type, you must click the "Add License" button to submit a request.',
  'OTP_desc': 'Web Manager Login 2 Step Verification with Google Authenticator',
  'agreement': {
    'desc': 'Please agree to the terms and conditions of use and personal information.',
    'agree_all': 'I agree to all terms and conditions',
    'agree_use': 'Accept the Terms and Conditions',
    'agree_use_context': `
      [Terms of Services]

      LINKMEMINE, Inc. (“LINKMEMINE” or “we”) provides the LINKMEMINE Web site including the LINKMEMINE Home Page and other LINKMEMINE contents including application program (collectively, the “LINKMEMINE Site”) subject to Customer’s compliance with the terms and conditions below. 

      This is a legal agreement between the individual or legal entity (“Customer” or “You”) agreeing to these Terms of Service (“Terms”) and LINKMEMINE.By accepting these Terms, signing an Order, or using the services, or checking the acceptance button on the page or application program and completing the electronic acceptance process, you represent and warrant that you

      1. are, or are authorized to sign for, the contracting party defined herein as 'Customer'.
      2. have read, understand and agree to be bound by all of the terms and conditions of this online subscription agreement.
      3. are of legal age and have authority to bind the Customer to the Order, these Terms, and the applicable “Service Descriptions” available at LINKMEMINE Site. 

      PLEASE READ THIS BEFORE ACCESSING THE LINKMEMINE SITE. BY ACCESSING THE LINKMEMINE SITE, YOU AGREE TO BE BOUND BY THE TERMS AND CONDITIONS BELOW.   IF YOU DO NOT WISH TO BE BOUND BY THESE TERMS AND CONDITIONS, YOU MAY NOT ACCESS OR USE THE LINKMEMINE SITE.

      This online subscription agreement ('Agreement') entered into of the date of electronic acceptance by Customer ('Effective Date'), by and between LINKMEMINE and Customer, entering into this Agreement. LINKMEMINE reserves the right to revise this Agreement from time to time without notice to Customer.


      Basic Rules

      While visiting the LINKMEMINE Site, Customer may also not: post, transmit or otherwise distribute information constituting or encouraging conduct that would constitute a criminal offense or give rise to civil liability, or otherwise use the LINKMEMINE Site in a manner which is contrary to law or would serve to restrict or inhibit any other user from using or enjoying the LINKMEMINE Site or the Internet; post or transmit any information or software which contains a virus, cancelbot, trojan horse, worm or other harmful or disruptive component; upload, post, publish, transmit, reproduce, or distribute in any way, information, software or other material obtained through the LINKMEMINE Site which is protected by copyright, or other intellectual property right, or derivative works with respect hereto, without obtaining permission of the copyright owner or rightsholder.

      You agree to use the Service in accordance with the use levels by which we measure, price and offer our Services as posted on LINKMEMINE Site, your Order, or the Service Descriptions (“Use Levels”). You may use our Services only as permitted in these Terms, and you consent to our Privacy Policy at LINKMEMINE Site.


      Services

      LINKMEMINE grants you a limited right to use LINKMEMINE Services for business and professional purposes only. Technical support for the Services is described in the Service Descriptions of LINKMEMINE Site. If your affiliates use our Services, you warrant that you have the authority to bind those affiliates and you will be liable if your affiliates do not comply with the Agreement.

      Customer may use LINKMEMINE remote software and related services only to enable a designated user to provide remote assistance to its customers. Customer may use LINKMEMINE   the Services only to enable authorized individuals to access and control designated users’ PCs and smart devices remotely.

      LINKMEMINE reserves the right to upgrade, enhance, or modify functions & features of the Services as it considers appropriate and in its discretion. LINKMEMINE will not materially reduce the core functionality (as set forth in the Service Descriptions) or discontinue any Services unless LINKMEMINE provides you with prior written notice. LINKMEMINE may offer additional functionality to our standard Services or premium feature improvements for an additional cost.

      Customer must complete the online registration process including this Agreement. LINKMEMINE may reject an online registration by a potential Customer in its sole discretion and is not obligated to provide a reason for the rejection. Customer or on behalf of Customer shall provide all registration data in accurate, current, and complete. The registration data should be updated by Customer in its sole responsibility. LINKMEMINE reserves the right to terminate this Agreement immediately in the event submitted registration data is found to be inaccurate, not current, or incomplete.

      During online registration process, LINKMEMINE will collect additional information on billing and payment related matters. It will include a valid credit card or debit card number with available credit, preferred billing frequency, and other information required by LINKMEMINE. LINKMEMINE reserves the right to terminate the Agreement immediately in the event any payment information is found to be inaccurate, not current or incomplete. Any overdraft charge or other fees that may be issued by LINKMEMINE’s use of Customer’s credit or debit card shall not be LINKMEMINE’s responsibility.

      Customer is entirely responsible for all activities under its account including management of keeping confidentiality of its password and account. Customer shall agree to inform LINKMEMINE immediately of any type of security breach. LINKMEMINE shall not be liable for any loss aroused from the Customer’s activity which may bring as a result of other entity using its password or account, either with or without its knowledge. Customer may be held liable for losses incurred by LINKMEMINE in such case as described above.

      Customer is responsible for all subscription fees and all applicable taxes (sales tax, value-added tax, goods and services tax, withholding tax, tarriffs, Universal Services Fund (USF) fees or any other similar fees and taxes) (collectively, the “Taxes and Fees”). Upon Customer’s payment of subscription fees, LINKMEMINE will allow Customer to access and use the services described above. All contents transferred by Customer or any other party in connection with Customer’s access and/or use of the services, of all kinds of communication methods, are shall be Customer’s responsibility. All payments you make to us for access to the Services are final and non-refundable. You are responsible for all fees and charges imposed by your voice and data transmission providers related to your access and use of the Services. 

      Customer may order Services using our then current ordering processes (“Order”). All Orders are effective on the earlier of the date you submit your Order or the date on the signature block of the Order (collectively, the “Effective Date”). Acceptance of your Order may be subject to our verification and credit approval process. 
      Customer is responsible for providing accurate and current billing contact and payment information to us or any reseller of ours. You agree that LINKMEMINE may take steps to verify whether your payment method is valid, charge your payment card or bill you for all amounts due for your use of the Services, and automatically update your payment card information using software designed to do so in the event your payment card on file is no longer valid. You agree that your credit card information and related personal data may be provided to third parties for payment processing and fraud prevention purposes. LINKMEMINE may suspend or terminate your Services if at any time LINKMEMINE determines that your payment information is inaccurate or not current, and you are responsible for fees and overdraft charges that LINKMEMINE may incur when we charge your card for payment. LINKMEMINE will not agree to submit invoices via any online portal. LINKMEMINE reserve the right to update the price for Services at any time after your Initial Term, and price changes will be effective as of your next billing cycle. LINKMEMINE will notify you of any price changes by publishing on our website, emailing, quoting or invoicing you.

      LINKMEMINE may offer a trial and/or promotional offers (promotions and other special discounted pricing offers) from time to time and the offers are temporary and upon the renewal of your subscription, any such discounted pricing offers may expire. LINKMEMINE reserves the right to discard or change coupons, credits, trials and promotional offers at its discretion and without notice. Just one (1) offer per customer is applied basically and limited to any kind of trial or promotional offers.

      You must notify us of any fee dispute within 15 days of the invoice date, and once resolved, you agree to pay those fees within 15 days. LINKMEMINE may, on notice to you, suspend or terminate your Services if you do not pay undisputed fees, and you agree to reimburse us for all reasonable costs and expenses incurred in collecting delinquent amounts.

      Customer must not reverse engineer, decompile or otherwise attempt to decipher any code in connection with the services or any other aspect of LINKMEMINE’s technology. Customer shall not access and/or use any of the services in any manner that could damage, disable, overburden, impair or otherwise interfere with or disrupt LINKMEMINE Site, services or related systems of LINKMEMINE. Customer may not resell, distribute, or use any of the services on a timeshare or disapproved method basis. 


      Monitoring

      LINKMEMINE has no obligation to monitor the LINKMEMINE Site. However, Customer agrees that LINKMEMINE has the right to monitor the LINKMEMINE Site electronically from time to time and to disclose any information as necessary to satisfy any law, regulation or other governmental request, to operate the LINKMEMINE Site properly, or to protect itself or its subscribers. LINKMEMINE will not intentionally monitor or disclose any private electronic-mail message unless required by law. LINKMEMINE reserves the right to refuse to post or to remove any information or materials, in whole or in part, that, in its sole discretion, are unacceptable, undesirable, or in violation of this Agreement.


      Termination

      LINKMEMINE reserves the right to terminate this Agreement immediately if Customer breaches any of its material obligations under the Agreement. Upon termination of the Agreement, Customer will immediately stop access to and use of the services. LINKMEMINE shall not be liable for any damages resulting from a termination of the Agreement. Provided, claims arising prior to the termination shall not be affected.


      The initial term commitment for your purchase of Services will be as specified on an Order (“Initial Term”) and begins on the Effective Date. After the Initial Term, the Services will, unless otherwise specified in the Service Description for a particular Service, automatically renew for additional 1-year periods (“Renewal Terms”), unless either party provides notice of non-renewal at least 30 days before the current term expires. You may provide notice of non-renewal for each Service you do not wish to renew at LINKMEMINE Site contacts. LINKMEMINE may agree to align the invoicing under multiple Orders but this will not reduce the term of any Order. Terminating specific Services does not affect the term of any other Services still in effect. If we permit you to reinstate Services at any time after termination, you agree that you will be bound by the then-current Terms and the renewal date that was in effect as of the effective termination date.

      If the Agreement or any Services are terminated, your account may be converted to a dormant account at our discretion. Otherwise, you will immediately discontinue all use of the terminated Services, except that upon request, LINKMEMINE will provide you with limited access to the Services for a period not to exceed 30 days, solely to enable you to retrieve your Content from the Services. LINKMEMINE has no obligation to maintain your Content after that period. Neither party will be liable for any damages resulting from termination of the Agreement, and termination will not affect any claim arising prior to the effective termination date. 

      You retain all rights to your Content (defined below) and LINKMEMINE does not own or license your Content. LINKMEMINE may use, modify, reproduce and distribute your Content in order to provide and operate the Services. You warrant that you have the right to upload or otherwise share Content with us, and your uploading or processing of your Content in the context of our Services does not infringe on any rights of any third party. Each party agrees to apply reasonable technical, organizational and administrative security measures to keep Content protected in accordance with industry standards. LINKMEMINE will not view, access or process any of your Content, except when it is authorized or instructed by you or your users in this Agreement or in any other agreement between the parties, or when it is required to comply with our policies, applicable law, or governmental request. You agree to comply with all legal duties applicable to you as a data controller by virtue of the submission of your Content within the Services. If your Content, including any personal data, is processed by us as a data processor acting on your behalf (in your capacity as data controller), LINKMEMINE will use and process your Content in order to provide the Services and fulfill our obligations under the Agreement, and in accordance with your instructions as represented in this Agreement. “Content” means any files, documents, recordings, chat logs, transcripts, and similar data that LINKMEMINE maintains on your or your users’ behalf, as well as any other information you or your users may upload to your Service account in connection with the Services.

      Privacy

      It is therefore recommended that the services shall not be used for the transmission of confidential information. LINKMEMINE cannot ensure or guarantee privacy for LINKMEMINE users. Any such use shall be at the sole risk of Customer and other users in connection with Customer, and LINKMEMINE and its affiliate and related companies shall be relieved of all liability in connection therewith.


      Limitation of Liability

      LINKMEMINE takes no responsibility for the accuracy or validity of any claims or statements contained in the documents and related graphics on the LINKMEMINE Site. Further, LINKMEMINE makes no representations about the suitability of any of the information contained in software programs, documents and related graphics on the LINKMEMINE Site for any purpose. All such software programs, documents and related graphics are provided without warranty of any kind. In no event shall LINKMEMINE be liable for any damages whatsoever, including special, indirect or consequential damages, arising out of or in connection with the use or performance of information available from the service. LINKMEMINE’s liability is limited to maximum $50.

      If Customer is dissatisfied with the LINKMEMINE Site or with any terms, conditions, rules, policies, guidelines, or practices of LINKMEMINE in operating the LINKMEMINE Site, Customer’s sole and exclusive remedy is to discontinue using the LINKMEMINE Site.


      Confidential Information
      Both parties shall not disclose non-public information or materials which are reasonably understood to be confidential (“Confidential Information”) except the case of any information that receiving party of Confidential Information is obligated to produce pursuant to an order of a court of competent jurisdiction with timely notice to disclosing party. Customer will keep in strict confidence all passwords and other access information to the services.

      Customer shall authorize LINKMEMINE to collect from any party and to retain all relevant information relating to Customer’s use of the LINKMEMINE Site, and hereby authorize any party to provide LINKMEMINE with such information. Customer shall understand and agree that unless Customer notify LINKMEMINE to the contrary by e-mailing, Customer further authorize LINKMEMINE to disclose, on a confidential basis, to any party with whom LINKMEMINE has business relations all relevant information relating to Customer’s dealings with LINKMEMINE and the LINKMEMINE Site.


      Indemnity

      Customer agrees, at its sole expense, to defend, indemnify and hold LINKMEMINE and its affiliate and related companies harmless from any and all liabilities, costs and expenses, including reasonable attorneys' fees, related to a third party claim, suit, or infringement based on information, data, or any content submitted by Customer or related to any Violation of this Agreement by Customer or users of Customer’s account, or in connection with the use of the LINKMEMINE Site or the Internet or the placement or transmission of any message, information, software or other materials on the LINKMEMINE Site or on the Internet by Customer or users of Customer’s account.



      Trademarks & Proprietary Rights

      LINKMEMINE and other names, logos and icons identifying LINKMEMINE and LINKMEMINE' products and services referenced herein are trademarks or registered trademarks of LINKMEMINE, Inc. All other product and/or brand or company names mentioned herein are the trademarks of their respective owners. LINKMEMINE, Inc. retains ownership of all proprietary rights in or associated with all its products and services.


      DISCLAIMER
      CUSTOMER HEREBY ACKNOWLEDGES AND AGREES THAT ALL MATERIALS CONTAINED IN THE SERVICES IS PROVIDED BY LINKMEMINE ON AN "AS IS" BASIS, AND CUSTOMER’S ACCESS TO AND/OR USE OF THE SERVICES IS AT ITS SOLE RISK WITHOUT WARRANTY OF ANY KIND. THE ENTIRE RISK AS TO THE RESULTS AND THE PERFORMANCE OF THE SOFTWARE IS ASSUMED BY THE USER, AND IN NO EVENT WILL LINKMEMINE BE LIABLE FOR ANY CONSEQUENTIAL, INCIDENTAL OR DIRECT DAMAGES SUFFERED IN THE COURSE OF USING THE SOFTWARE IN THE SERVICES. USE OF ANY MATERIAL AND/OR DATA DOWNLOADED OR OBTAINED PROGRAMS (INCLUDING PLUG-INS) CONTAINED IN THE SERVICES IS DONE AT THE SOLE RISK OF CUSTOMER. CUSTOMER WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO ITS COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF SUCH MATERIAL AND/OR DATA.


      Headings

      The headings used in this Agreement are used for convenience only and are not to be considered in construing or interpreting this Agreement.


      Force Majeure

      LINKMEMINE shall not be responsible for delays or failure to perform resulting from acts beyond the reasonable control of such party and which could not have been reasonably foreseen and provided against and with respect to which such party shall exercise continuing diligence to resume performance of its obligations. Such acts shall include, without limitation, acts of God, fires, casualties, floods, earthquakes, acts of war, strikes, lockouts, epidemics, destruction of production facilities, riots, insurrections, walkouts, government order, power failures, and other disasters.


      No Waiver & Severability

      The failure of either Customer or LINKMEMINE in any one or more instance(s) to insist upon strict performance of any of the terms of this Agreement will not be construed as a waiver or relinquishment of the right to assert or rely upon any such term(s) on any future occasion(s). In the event that any provision of this Agreement (or portion thereof) is determined by a court of competent jurisdiction to be invalid or otherwise unenforceable, such provision (or part thereof) shall be enforced or, incapable of such enforcement, shall be deemed to be deleted from this Agreement, while the remainder of this Agreement shall continue to remain in full force and effect according to its stated terms and conditions.


      COMPLIANCE WITH LAWS. IN CONNECTION WITH THE PERFORMANCE, ACCESS AND USE OF THE SERVICES UNDER THE AGREEMENT, EACH PARTY AGREES TO COMPLY WITH ALL APPLICABLE LAWS, RULES AND REGULATIONS INCLUDING, BUT NOT LIMITED TO EXPORT, PRIVACY, AND DATA PROTECTION LAWS AND REGULATIONS. IF NECESSARY AND IN ACCORDANCE WITH APPLICABLE LAW, LINKMEMINE WILL COOPERATE WITH LOCAL, STATE, FEDERAL AND INTERNATIONAL GOVERNMENT AUTHORITIES WITH RESPECT TO THE SERVICES. NOTWITHSTANDING ANY OTHER PROVISION IN THESE TERMS, WE MAY IMMEDIATELY TERMINATE THE AGREEMENT FOR NONCOMPLIANCE WITH APPLICABLE LAWS.


      WARRANTIES. WE WARRANT THAT THE SERVICES WILL CONFORM TO THE SERVICE DESCRIPTIONS UNDER NORMAL USE. WE DO NOT REPRESENT OR WARRANT THAT (1) THE USE OF OUR SERVICES WILL BE TIMELY, UNINTERRUPTED OR ERROR FREE, OR OPERATE IN COMBINATION WITH ANY SPECIFIC HARDWARE, SOFTWARE, SYSTEM OR DATA, (2) OUR SERVICES WILL MEET YOUR REQUIREMENTS, OR (3) ALL ERRORS OR DEFECTS WILL BE CORRECTED. USE OF THE SERVICES IS AT YOUR SOLE RISK. OUR ENTIRE LIABILITY AND YOUR EXCLUSIVE REMEDY UNDER THIS WARRANTY WILL BE, AT OUR SOLE OPTION AND SUBJECT TO APPLICABLE LAW, TO PROVIDE CONFORMING SERVICES, OR TO TERMINATE THE NON-CONFORMING SERVICES OR THE APPLICABLE ORDER, AND PROVIDE A PRO-RATED REFUND OF ANY PREPAID FEES FROM THE DATE YOU NOTIFY US OF THE NON-CONFORMANCE THROUGH THE END OF THE REMAINING TERM. TO THE EXTENT PERMITTED BY APPLICABLE LAW, WE DISCLAIM ALL OTHER WARRANTIES AND CONDITIONS, WHETHER EXPRESS, IMPLIED, STATUTORY OR OTHERWISE, INCLUDING ANY EXPRESS OR IMPLIED WARRANTIES OF MERCHANTABILITY, SATISFACTORY QUALITY, TITLE, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES AND CONDITIONS, THEREFORE SOME OF THE ABOVE EXCLUSIONS MAY NOT APPLY TO CUSTOMERS LOCATED IN THOSE JURISDICTIONS.




    `,
    'agree_privacy': 'Accept to the collection/use of personal information',
    'agree_privacy_context': `
      [Privacy Policy]

      LinkMeMine service, as described in Terms of Service of LinkMeMine Site, is a remote support service provided by LinkMeMine, Inc. In this Privacy Policy, we explain what personal data we collect from visitors to the LinkMeMine website(s) and/or properties that link to this Privacy Policy (including digital properties) and how we use such personal data.

      Your privacy is important to us. To protect your privacy better, we provide this policy explaining our online information practices and the choices you can make about the way your information is collected and used. To make this policy easy to find, we make it available on our website(s) and at every point where personally identifiable information may be requested.

      When you visit our website(s), and/or use our Services, you provide following personal data to us. 

      Data Information and Collection

      This notice applies to all information collected or submitted on the LinkMeMine Site. On some pages, you can order products, make requests, and register to receive services and related materials. The types of personal information that you provide at these pages are typically including first and last name, billing data, and a valid email address, postal address, and other demanding information for the service when you create your account with us, request support or technical assistance, or register for events, webinars, whitepapers and surveys.
      We need this data to provide the Services to you, to maintain and support your account, as well as to collect payment. Legal basis for the processing of this data is our legitimate interest to do business with you, your employer or business and perform our contractual obligations under the applicable Services agreement.

      When you use our Services, we receive information through the use of the Service, either voluntarily entered by you or others who use the Services with you, or from the Service infrastructure itself. Service Data includes session and usage data, device information, as well as data automatically logged by the website(s) or Services, for example, duration of session, connections made, hardware, equipment and devices used, IP addresses, location, language settings, operating system used, unique device identifiers, IP addresses and other diagnostic data to help us provide better Services.


      Use of Information Collected

      We use the information you provide about yourself when you are using our services, placing and completing an order, and doing other activities of or related to our website(s) and services. We do not share this information with outside parties except to the extent necessary to maintain the services, to complete that order, to confirm processes, and to analyze our website(s).
      We use the data we collect from visitors to our website(s). 
      1) to provide and operate our Services; 
      2) to maintain and improve our Services; 
      3) to provide product updates, marketing communications, and service data; 
      4) to provide analysis or valuable data back to our customers and users; 
      5) to address and respond to service, security, and customer support needs; 
      6) to detect, prevent, or otherwise address fraud, security, unlawful, or technical issues; 
      7) to display content based upon your interests; 
      8) to comply with applicable laws and administrative requests, protect our rights, assert and defend against claims; 
      9) to fulfill contracts; 
      10) to assess the needs of your business to determine and promote other related products which we believe may be helpful to you; 
      11) to conduct research and analysis for business planning and product development; 
      12) to the extent permitted by law, we may combine, correct and enrich personal data that we receive from you with data about you from other sources, including publicly available databases or from third parties to update, expand and analyze our records, identify new prospects for marketing, and provide products and Services that may be of interest to you.
      We continuously improve our website(s) and Services through the use of web analytics tools and first and third-party cookies, which help us understand how our visitors use our website(s), desktop and mobile applications, what webpages, features and functions they like and dislike, and where they may have run into problems which need to be addressed.

      We use non-identifying and aggregate information to better design our website(s) and to share with advertisers. For example, we may tell an advertiser that X number of individuals visited a certain area on our website(s), or that Y number of men and Z number of women filled out our registration form, but we would not disclose anything that could be used to identify those individuals.

      We never use or share the personally identifiable information provided to us online in ways unrelated to the ones described above without also providing you an opportunity to opt-out or otherwise prohibit such unrelated uses.
      Data Security

      To prevent unauthorized access, maintain data accuracy, and ensure the correct use of information, we have put in place appropriate physical, electronic, and managerial procedures to safeguard and secure the information we collect online.

      Within our organization, we apply access controls to limit the recipients of personal data on a "need to know" basis. Our customer support and technical staff, billing and finance personnel, and representatives of our legal and audit departments have access to your data as necessary for the legitimate purposes of our data processing


      Children's Privacy
      Protecting the privacy of the very young is especially important. For that reason, we do not seek through our sites to gather personal data from or about persons that are minors (i.e., not the age of majority). If you inform us or we otherwise become aware that we have unintentionally received personal data from a minor, we will delete this information from our records.

      Access or Correct Your Information

      We update this Privacy Policy from time to time to reflect changes to our personal data handling practices or respond to new legal requirements and will post updates here. However, if we make any material changes that have a substantive and adverse impact on your privacy, we will provide notice on this(these) website(s) and additionally notify you by email (sent to the e-mail address specified in your account) for your approval prior to the change becoming effective. We encourage you to periodically review this page for the latest information on our privacy practices.

      You can access all your personally identifiable information that we collect online and maintain by login procedure. We use this procedure to better safeguard your information.

      You can correct factual errors in your personally identifiable information by sending us a request that credibly shows error.

      To protect your privacy and security, we will also take reasonable steps to verify your identity before granting access or making corrections.



      Contact Us	

      Subject to conditions specified by applicable law, persons have the right: 	
      1) to inquire whether and what kind of personal data we hold about you and how it is processed, and to access or request copies of such personal data; 
      2) to request the correction or supplementation of personal data about you that is inaccurate, incomplete or out-of-date in light of the purposes underlying the processing; 
      3) to request to obtain the erasure of personal data no longer necessary for the purposes underlying the processing, processed based on withdrawn consent, processed for legitimate interests that, in the context of your objection, do not prove to be compelling or necessary for the establishment, exercise or defense of legal claims, or processed in non compliance with applicable legal requirements. 

      In addition, you have, subject to the conditions set out in applicable law and without limitation, the rights: 
      1) to request us to restrict the processing of personal data in certain situations where you feel its processing is inappropriate; 
      2) to object, on grounds relating to your particular situation or where your personal data is used for direct marketing purposes, to the processing of personal data for legitimate interests; 
      3) to request portability of personal data that you have provided to us, where the processing of such personal data is based on consent or a contract with you and is carried out by automated means. In case of concerns, you also have the right to lodge a complaint with a supervisory authority having appropriate jurisdiction. 

      Under certain circumstances we will not be able to fulfill your request, such as if it interferes with our regulatory obligations, affects legal matters, we cannot verify your identity, or it involves disproportionate cost or effort, but in any event, we will respond to your request within thirty (30) days and provide you an explanation.
      If you have questions or requests relating to our privacy practices and this Privacy Policy or would like to exercise the mentioned (above) rights of access, rectification, erasure, restriction, objection and data portability, you may contact us using contact information at our website(s).
      Please note that for personal data about you that we have obtained or received for processing on behalf of a separate, unaffiliated entity – which determined the means and purposes of processing, all such requests should be made to that entity directly. We will honor and support any instructions they provide us with respect to your personal information. 
      If you wish to no longer receive marketing communications from us, you also can contact via the contact information of our website(s).



    `
  },
  'help_otp':` 
    <h5>2-Step Verification Setting using Google OTP</h5>
    <section style="margin:30px 0;">
      <h6>1. Activate 2-Step Verification (OTP)</h6>
      <p style="margin-left: 12px;">Click to slide the toggle switch to activate (it should turn green).<br>
      Click to reset OTP settings.</p>
    </section>
    <section style="margin:30px 0;">
      <h6>2. Install Google OTP from Google Play Store or the App Store.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>3. Run Google OTP.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>4. Logout and log back in. You should see a window to register Google OTP.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>5. Select barcode scan in the Google OTP app and register.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>6. Enter in the 6-digit verification code and login.</h6>
    </section>
  `,
  'help_manager': `
    <h5>What are submanager permission?</h5><br>
    <b>Submanager ("Approved by")</b>: Can modify user permission and approve or deny remote access request.<br><br>
    <b>User ("Requested by")</b>: Can be approved by the submanager to access and monitor device(s).
  `,
  'help_vaccine': `
    <h5>Allowed Program Help</h5><br>
    <h6> Enter the name of the installed program (excluding .exe files) to allow.
    </h6>
    <h6 style="padding:0 0 20px 0;">(Leave blank if not using any program)</h6>
  `,
  'help_os': `
    <h5>OS Version Help</h5><br>
    <h6 style="padding:0 0 20px 0;">
      Check the version of your OS below and enter the appropriate number.<br>
    </h6>
    <table>
      <th>OS</th>
      <th style="padding-right:20px;">Major Version</th>
      <th>Minor Version</th>
      <tr>
        <td>Window Server 2019</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window 10</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Server 2016</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Server 2012 R2</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">3</td>
      </tr>
      <tr>
        <td>Window 8.1</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">3</td>
      </tr>
      <tr>
        <td>Window 8</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window Server 2012</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window 7</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window Server 2008 R2</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window Server 2008</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Vista</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Home Server</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window Server 2003</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window XP Professional x64 Edition</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window XP</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window 2000</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">0</td>
      </tr>
    </table>
  `,
  'ip_delete_all_warning':'Do you want to delete ALL the items on the IP List?',
  'ip_delete_all':'Delete All IP',
  'ip_block_reject':`IP is blocked.<br>Contact your administrator.`,
  'ip_white_reject':`IP is is not permitted.<br>Contact your administrator.`,
  'search_manager_200':`Approver has been selected.`,
  'search_manager_405':`Please check the approver ID.`,
  'search_approver_null':'If blank, the approver will be set as the administrator by default.',
  'date_validate_error':'Please check the request date.',
  'approvals_reason':'Please enter the reason for request.',
  'search_approver_placeholder':'Enter the approver ID.',
  'approval-success': `Access request has been made.`,
  'function-settings-desc01': 'I choose to allow file transfer when creating submanager and user accounts.',
  'blocking-settings-desc01': 'Deny access by registering blocked IP list.',
  'blocking-settings-desc02': 'Deny access by registering allowed IP list.',
  'function-submit': 'Your function settings have been changed.',
  'blocking-submit': 'Your security settings have been changed.',
  'blocking-super-settings-desc': 'Security settings have been activated.',
  'reset-pw-repeat': 'Do you want to reset your password?',
  'reset-pw-submit': 'Your password has been reset.<br>Password: koino1807!', //
  'registration-access': 'Request access has been approved.',
  'registration-reject': 'Request access has been denied.',
  'registration-access-error': 'You may not make an approval if you enter the reason for denial.',
  'registration-reject-error': 'Enter the reason for denial.',
  'login_failed_cause_ip_reject': 'Blocked by the IP settings.',
  'login_failure_limit':'You have made too many login attempts.<br>Please contact your administrator.',
  'registration-approve':'Approve or Deny',
  'registration-reject-history':'Do you want to change the decision?',
  // 추가
  'help_ip_add':`
    <h5>IP Help</h5><br>
    <h6 style="font-weight:bold;">
      Add single IP
    </h6>
    <h6 style="padding:0 0 20px 0;">Only the IP entered will be added.</h6>
    <h6 style="font-weight:bold;">
      Add IP range
    </h6>
    <h6 style="padding:0 0 20px 0;">
      IP address included in the start range to the end range will be added.<br>
      ex. 192.168.0.0 ~ 192.168.0.255
    </h6>
    <h6 style="font-weight:bold;">
      Add subnet IP
    </h6>
    <h6 style="padding:0 0 20px 0;">
      IP addresses partitioned by subnet will be added.<br>
      ex. 192.168.32.0/24
    </h6>
    <h6 style="font-weight:bold;">
      Add via Excel
    </h6>
    <h6 style="padding:0 0 20px 0;">
      Click the <span style="color:#38d2b8;font-weight:bold;">'Excel File Template'</span> below to download. 
      Fill out the form and upload.<br><br>
      You may add a single IP and/or subnet IP address. <br>
      Enter in the start IP address and leave the end address blank.<br><br>
      If adding a IP range, please enter both the start and end IP addresses.<br><br>      
      Only valid IP address will be added.
    </h6>
  `,
  'ip_range_error':'Please check your IP address.',
  'ip_range_blank':'Enter IP address.',
  'ip_excel_no_file':'Upload Excel File.',
  'user_in_group_add':'Enter the ID of the user to add.',
  'user_in_group_no_exist':'User does not exist.',
  'user_in_group_overlap':'User already exists in this group.',
  'user_in_group_blank':'Enter the ID of the user to add.',
  'user_in_group_add_success':'User successfully added.',
  'user_in_group_remove_success':'User successfully deleted.',
  // 'start_time':'Start Date',
  'start_time_time':'Start Time',
  // 'end_time':'End Date',
  'end_time_time':'End Time',
  'auth_failure_num_desc':'If the user exceeds the number of allowed failed attempts, the account will be locked.',
  'auto_block_time':'If the set remote session duration is not used after session starts, session will automatically terminate.',
  'os_version_desc':'User environment is checked, and only the access from the higher version of Windows device(s) will be allowed.',
  'session_timie_desc':'Session will automatically terminate if session exceeds the set time limit (program will terminate even during session).',
  // @@@ 영어로 번역
  'password_level_desc':'Adjust the password difficulty level when you create a user.',
  'capture_desc':'Block/allow screen capture or record function.',
  'display_power_save_desc':'Block/allow power saving mode (display) during remote session.',
  'system_power_save_desc':'Block/allow power saving mode (system) during remote session.',
  'security_agreement_desc':'Change security settings to allow specific users to have access.',
  'function_settings_header':'* Policy Setting: Administrators can change settings for submanagers and users, like remote functions and access environments.',
  'vaccine_desc':'Access is granted only to the user environment running a specified anti-virus program.',
  'invalid_idle_time':'Please check the remote access idle time limit (min).',
  'invalid_session_time':'Please check the permitted remote session duration (min).',
  'invalid_block_num':'Please check the allowed number of failed verification attempts.',
  'invalid_min_os_major':'Check the major OS version.',
  'invalid_min_os_minor':'Check the minor OS version.',
  'password_modified_error':'Please check the current password.',
  'password_change_limit':'Password usage has expired.<br>Please change your password.',
  'password_expired_desc':'You must change your password before logging in.',
  'invalid_password_change_limit':'Check the Password maximum age (days)',
  'help_PWChangeLimit': `
    <h5>Password Maximum Age Help</h5><br>
    <h6 style="line-hight:1em;">
      Sets the maximum duration for which passwords can be used.<br>
      You can set up to 365 days (1 year).<br>
    </h6>
    <h6 style="padding:20px 0 0 0">
      (Enter 0 if not used)
    </h6>
  `,
  'excel_onloaded':'Only the data with the correct syntax will be added.<br>Select the user to add and submit.',
  'excel_user_submit':'User data was successfully changed with the exception of {failure} error(s).',
  'excel_group_submit':'Group data was successfully changed with the exception of {failure} error(s).',
  'excel_group_fail':'Failed to add multiple groups.<br>Please check the data in your Excel file.',
  'groups':'Groups',
  'users':'Users',
  'dashboard':'Dashboard',
  'payment_manage':'Payment',
  'subscription':'Subscription',
  'payment_history':'Payment History',
  'deleted_device_history':'Deleted Device History',
  'add_user':'Add User',
  'add_group':'Add Group',
  'access_time':'Access Time',
  'no_devices':'No. of Device(s)',
  'add_ip':'Add IP',
  'delete_ip':'Delete IP',
  'add_ip_single':'Add single IP',
  'add_ip_range': 'Add IP range',
  'add_ip_subnet':'Add subnet IP',
  'add_ip_excel':'Add via Excel',
  // @@@
  'device_excel_fail': 'Failed to generate Excel.',
  'mode_simple': 'SIMPLE',
  'mode_normal': 'NORMAL',
  'icon_access': 'IN ACCESS',
  'icon_online': 'ONLINE',
  'icon_offline': 'OFFLINE',
  'excel_button' : 'EXCEL',
  'no-agent-selected': 'No agents selected. Changing the page will reset your selection.',
  'add-group-child': 'Add Group - Subgroup',
  'chat_talk': 'Chat Talk',
  'customer_support': 'Support',
  'payment_account_info': '<b>Acct No.:</b> 1005-101-071339<br>\n' +
    '<b>Bank:</b> Woori Bank<br>\n' +
    '<b>Holder:</b> LinkMeMine Co., Ltd.<br>\n' +
    '<small>(For payment confirmation, please reach us via Chat Talk.)</small>',
  'vol_input_warning': 'A corporate license must register at least 5 items.',
  'invalid_data': 'Please enter a valid value.',
  'manual_input': 'Manual Input',
  'excel_processing_delayed': 'The requested Excel data is taking longer than expected to process. Try reducing the date range or applying filters.',
  'join_form': {
    'required_field': 'Required Field',
    'optional_field': 'Optional Field',
  },
  "agent_installer_file": "Agent Installer File",
  "agent_file_description": "The agent is installed and logged in automatically using the same account.<br>Suitable for installing the agent on multiple devices.",
  "install_type": "Installation Type",
  "access_account_setting": "Access Account Setting",
  "enter_password": "Please enter your password",
  "access_permission_setting": "Access Permission Setting",
  "installer_file_expiration_date": "Expiration Date",
  "select_expiration_date": "Select Expiration Date",
  "proxy_server_setting": "Proxy Server Setting",
  "proxy_server": "Proxy Server",
  "proxy_port": "Proxy Port",
  "proxy_id": "Proxy ID",
  "proxy_password": "Proxy Password",
  "generate_installer_file": "Create Installer",
  "auto_login_install_mode": "Auto Login Install",
  "manual_login_install_mode": "Manual Login Install",
  "disabled": "Disabled",
  "manual_setting": "Manual Setting",
  "auto_setting": "Automatic Setting",
  "login_failed_invalid_credentials": "Login failed. Please check your username or password and try again.",
  "file_download_error": "An error occurred while downloading the file.",
  "agent_auto_login_agreement_text": "Terms of Service for LinkMeMine Software and its Services\n\nThe Software Product is protected by copyright laws and international copyright treaties, as well as other intellectual property laws and treaties.\nThe Software Product includes computer software, associated media, printed materials and “online” or electronic documentation. The Software Product also includes all executables, add-ins, user manuals, help files, and other files but not limited. The term “Use” refers the act to store, install, execute, or display the Software Product on the computer’s main memory or temporary storage RAM, CD-ROM, or other storage device.\n\n1. Access and Use of the Services.\nYour right includes the right to use the Software Product itself and the use of the accompanying services.\nRight to Use Software: You may install, use, access, run or otherwise interact with the Software Product on a single or multiple computers. Any reproduction or redistribution of any Software Product that violates this Agreement is prohibited by law and may result in severe civil and criminal penalties\nRight to Use Services: The term “Services” refers to set up the necessary conditions for remote control by installing the Software Product on a specific computer and registering it through login process.\n\n2. Copyright\nAll title and copyrights in and to the Software Product (including but not limited to any images, video, music and text) are owned by LinkMeMine and its suppliers. This Software Product is licensed, not sold. Therefore, no ownership rights or other rights regarding this Software Product are transferred to you, and the license under this Agreement shall not be construed as a sale of rights to the Software Product. However, if you comply with the terms of this License Agreement, you may make one additional copy of the Software Product for backup or archival purposes. Otherwise, you may not make additional copies of the Software Product. You may not copy the printed materials attached to this Software Product. All other rights not expressly granted under this Agreement are located at LinkMeMine Corporation.\n\n3. DESCRIPTION OF OTHER RIGHTS AND LIMITATIONS\nBy using our Services, you agree on behalf of yourself, your users and your attendees, not to (ⅰ) modify, prepare derivative works of, or reverse engineer, our Services; (ⅱ) knowingly or negligently use our Services in a way that abuses or disrupts our networks, user accounts, or the Services; (ⅲ) transmit through the Services any harassing, fraudulent of unlawful material; (ⅳ) market, or resell the Services to any third party without our permissions; (ⅴ) use the Services in violation of our policies, applicable laws, or regulations; (ⅵ) use the Services to send unauthorized advertising, or spam; (ⅶ) harvest, collect, or gather user data without their consent; or (ⅷ) transmit through the Services any material that may infringe the intellectual property or other rights of third parties.\n\n4. WARRANTY LIMIT\nWarranty: LinkMeMine Corporation warrant that the services will conform to the service descriptions under normal use for 90 days from the date of purchase. We will make reasonable effort to solve any problem or defects. If exchange is required, the product should be within 90 days of purchase. In the event of user’s negligence, mistake or inadequate use, exchange is not an option.\nLimited Warranty: You agree to the entire risk as to the use and performance of this software product. LinkMeMine Corporation and its suppliers disclaim all warranties, express or implied, to the maximum extent permitted by applicable law. LinkMeMine does not warrant that the functions in Software Product will meet your requirements or that there will be no temporary interference or error when using this Software Product. LinkMeMine is not responsible for any problems caused by changes in the operating characteristics of computer hardware and computer operation systems (OS) manufactured after the shipment of this Software Product.\nCustomer Remedies: LinkMeMine’s and its suppliers’ entire liability and your exclusive remedy shall be, at LinkMeMine’s option, either (ⅰ) replacement of the product or (ⅱ) repair or replacement of the Software Product that does not meet LinkMeMine’s Limited Warranty. It will be made by returning a copy of your receipt and the Software Product to LinkMeMine Corporation within the warranty period. Software Product purchased through the electronic medium under the “electronic distribution via electronic medium” may receive remedial action by sending the proof of purchase to LinkMeMine within the warranty period.\nNo Other Warranties: LinkMeMine Corporation does not take any responsibility for the promise made by LinkMeMine’s suppliers, distributors and other third parties using oral, written and other notice means.\nIndemnity for Damages: LinkMeMine and its suppliers are not responsible for any damages caused by the use or non-availability of the Software Product and the provision of support services or their default to the maximum extent permitted by applicable law. Any damages in connection with the foregoing shall not be construed as liability to LinkMeMine in any case (whether by tort, contract, or other cause). Even if LinkMeMine notices of the possibility of such damages, LinkMeMine shall not be liable for the above damages and shall not be liable for any claims made by third parties. You acknowledge that the license fees already reflect this risk. Under this Agreement, the liability of LinkMeMine shall not exceed the amount you paid to use the services, and in the case of support services, you shall either re-provide the service or refund the fee.\n\n5. GENERAL TERMS\nThis is a legal agreement between you (either a person or an organization) and LinkMeMine Corporation for the LinkMeMine software product identified above, which includes computer software and services we (LinkMeMine) provide to you (“Customer”). This agreement replaces any previous agreement written or spoken in any form. If you have any question concerning this agreement, please contact us (LinkMeMine) through e-mail (support@linkmemine.com), phone (070-7126-8663) or post (LinkMeMine Co., Ltd, 18F 1807, Digital Road, 288, Guro-gu, Seoul, Korea).",
  "auto_install_multiple": "Auto Install",
  "single_agent_install": "Single Install",
  
}
